import slugify from '@sindresorhus/slugify';

export const formatSlug = (slug: string, isPremium = false): string => {
  if (isPremium) {
    return `/premium-ultra/${slug ? slugify(slug) : ''}`;
  }

  return `/${slug ? slugify(slug) : ''}`;
};
